import { useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { object, array, string } from 'yup';

import { RootState } from 'src/index';
import R from 'src/routes';
import {
  updateCreatorApplication,
  apply,
} from 'src/store/actions/creatorApplication';
import {
  CreatorApplicationThreeContainerProps,
  CreatorApplicationThreeProps,
  CreatorApplicationThreeFormContent,
} from './CreatorApplicationThree.types';
import { CreatorApplicationThree } from './CreatorApplicationThree.component';

const validationSchema = object({
  audience: object({
    countries: array(string().required('Must provide a country.')).required(),
  }).required(),
}).required();

const CreatorApplicationThreeContainer: React.FC<
  CreatorApplicationThreeContainerProps
> = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const initialValues = useSelector<
    RootState,
    CreatorApplicationThreeFormContent
  >(({ creatorApplication }) => ({
    audience: {
      countries: [...creatorApplication.audience.countries],
    },
  }));

  const signedUpInThisSession = useSelector<RootState, boolean>(
    ({ ui }) => ui.signedUpInThisSession,
  );

  const handleSubmit = useCallback<CreatorApplicationThreeProps['onSubmit']>(
    async (values, actions) => {
      dispatch(updateCreatorApplication(values));
      await dispatch(apply());
      actions.setSubmitting(false);
      // If user just signed up, go to the post sign up page after the user has
      // gone through the creator application.
      // Go to the home page otherwise.
      if (signedUpInThisSession) {
        history.push(R.POSTSIGNUP);
      } else {
        history.push(R.HOME);
      }
    },
    [dispatch, history, signedUpInThisSession],
  );

  const formRef: CreatorApplicationThreeProps['formRef'] = useRef(null);

  const handleBack = useCallback(() => {
    if (formRef.current) {
      const audience = {
        countries: [formRef.current['audience.countries[0]'].value],
      };

      dispatch(updateCreatorApplication({ audience }));
    }
    history.push(R.CREATOR_APPLICATION_TWO);
  }, [dispatch, history]);

  return (
    <CreatorApplicationThree
      initialValues={initialValues}
      validationSchema={validationSchema}
      formRef={formRef}
      onSubmit={handleSubmit}
      onBack={handleBack}
      {...props}
    />
  );
};

export { CreatorApplicationThreeContainer as CreatorApplicationThree };
